import { IDelegateWorkPatientsRequest } from "./workListsApi";

import msalApi from "../config/setupMSALAxios"; // your configured Axios instance

// import { todaysDateFormatted } from '@/utilities/dateUtilities'

//? NEW
enum TaskActions {
  Add,
  Edit,
  Delete,
  Reply,
  Status,
  ReAssign,
}

export function todaysDateFormatted() {
  let date = new Date();
  return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
}

// * Task Comments
export async function postTaskComment(id: string, patientId: number, comment: string) {
  // // // //console.clear()()
  // // console.log('*****   POSTing FROM API :::  postTaskComment')
  // // console.log(' 										id: ',id)
  // // console.log(' 										patientId: ',patientId)
  // // console.log(' 										comment: ',comment)

  const postTask = { action: TaskActions.Add, id, CommentId: "", comment, PersonId: patientId };
  const result = await msalApi.post("/api/Campaign/PostTaskComment", postTask);
  return result.data;

  //? REFACTOR 2 THIS
  //return msalApi.post('/Campaign/PostTaskComment', postTask).then((response) => {      response.data    })
}
export async function replyTaskComment(data) {
  const commentId = data.commentId;
  const id = data.Id;
  const replyText = data.replyText;
  const patientId = data.patientId;
  const postTask = { action: TaskActions.Reply, Comment: replyText, commentId, id, PersonId: patientId };
  const result = await msalApi.post("/api/Campaign/PostTaskComment", postTask);
  return result.data;

  //todo REFACTOR 2 THIS
  // return msalApi
  //   .post('/API/Campaign/PostTaskComment', {
  //     commentId,
  //     id,
  //     commentText,
  //      action: TaskActions.Reply,
  //   })
  //   .then((response) => response.data)
}
export async function editTaskComment(data) {
  const commentId = data.commentId;
  const id = data.Id;
  const editValue = data.editValue;
  const patientId = data.patientId;
  const postTask = { action: TaskActions.Edit, Comment: editValue, commentId, id, PersonId: patientId };
  const result = await msalApi.post("/api/Campaign/PostTaskComment", postTask);
  return result.data;
}
export async function deleteTaskComment(data) {
  const commentId = data.commentId;
  const id = data.Id;
  const patientId = data.patientId;
  const postTask = { action: TaskActions.Delete, commentId, id, PersonId: patientId };
  const result = await msalApi.post("/api/Campaign/PostTaskComment", postTask);
  return result.data;

  //todo REFACTOR
  //  return msalApi.delete('/api/Campaign/PostTaskComment', {
  //       params: {
  //       commentId: commentId,
  //           action: TaskActions.Delete,
  //       }
  //     })
  //     .then((response) => response.data)
}

// TODO
// * Put Task Status
export async function putTaskStatus(id: string, patientId: number, comment: string, status: string) {
  //// // //console.clear()()
  // console.log('  putTaskStatus							putTaskStatus							putTaskStatus										0000000000000000000000000000000000000000000000000000    PUT TASK STATUS                   discDATA API  putTaskStatus ')

  // console.log(id)
  // console.log(' id: ' + id + ' patientId: >>>>>>>>> ' + patientId)
  // console.log('*******************************		PersonId: patientId * *************************')

  const postTask = { action: TaskActions.Status, Id: id, CommentId: "", Comment: comment, PersonId: patientId, Status: status };
  // console.clear()
  // console.log(' DISCRETE *** DATA: 	putTaskStatus	POST TASK   /Campaign/PutTaskStatus')
  // console.dir(postTask)

  const result = await msalApi.put("/api/Campaign/PutTaskStatus", postTask);
  return result.data;

  //? REFACTOR 2 THIS
  //return msalApi.post('/api/Campaign/PostTaskComment', postTask).then((response) => {      response.data    })
}

//! POST Task REASSIGN
export async function postReAssignWork(id: string, comment: string, recipientsOne: string) {
  // // // //console.clear()()

  const postReassignTask = { Id: id, Comment: comment, recipientsOne: recipientsOne };
  // console.log('POST REASSIGN WORK API   >>')
  // console.dir(postReassignTask)

  const result = await msalApi.post("/api/Campaign/PostReassignWork", postReassignTask);
  return result.data;

  // // // console.log('  						postReAssignWork	   POST TASK REASSIGN :                   discDATA API  postReAssignWork ')
  // // // console.log(' id: ' + id + ' comment: ' + comment + '   recipients:  ' + recipients)
  // // // console.log('*******************************	recipients  *************************')

  // // const postTask = { action: TaskActions.Status, id, CommentId\ '', comment, PersonId: patientId, Status: status }
  // const postReassign = { id, comment, recipients }
  // //// // //console.clear()()
  // // // console.log('																											 DISCRETE *** DATA: 	postReassign	POST TASK   /Campaign/PostReassignWork')
  // // // console.dir(postReassign)

  // const result = await msalApi.put('/Campaign/PostReassignWork', postReassign)
  // return result.data

  //? REFACTOR 2 THIS
  //return msalApi.post('/Campaign/PostTaskComment', postTask).then((response) => {      response.data    })
}

// // COMMUNICATIONS Comments
export async function postCommunicationsComment(id: string, parentId: string, patientMessageID: number, comment: string) {
  // //console.clear()()
  // console.log('				discDATA API postCommunicationsComment :   			*****   POSTing FROM API :::  postTaskComment')
  // console.log('				BUILDING  postTask OBJECT  >>>>>>>  ')
  // console.log(' 									action: TaskActions.Add,   ')
  // console.log(' 										id: ', id)
  // console.log(' 								ParentId		parentId: ', parentId)
  // console.log(' 										patientMessageID: ', patientMessageID)
  // console.log(' 										comment: ', comment)

  const postTask = { action: TaskActions.Add, id: "", ParentId: parentId, patientMessageID, comment };

  // console.log('postTask OBJECT ' )
  // console.dir(postTask)

  const result = await msalApi.post("/api/Patient/PostCommunicationsComment", postTask);

  return result.data;

  //? REFACTOR 2 THIS
  //return msalApi.post('/Campaign/PostTaskComment', postTask).then((response) => {      response.data    })
}
export async function replyCOMMsComment(data) {
  // //console.clear()()
  // console.log('🚀 ----------------------------------------------------------------------------------------------------🚀')
  // console.log('🚀 ~ file: discreteDataApi.ts ~ line 147 ~ replyCOMMsComment ~ replyCOMMsComment  data: ' + data)
  // console.log('🚀 ----------------------------------------------------------------------------------------------------🚀')

  // console.log('22222')
  // console.dir(data)
  // console.log('22222')

  // console.log('--------------------------------  end ')

  // console.log('--------------------------------  end ')

  const parentId = data.ParentId;
  const id = data.Id;
  const replyText = data.replyText;
  //const patientId = data.patientId

  // console.log(' SENDING _________end        parentId: ' + parentId + ' id: '+ id+	'replyText: '+replyText)
  //	const postTask = { action: TaskActions.Add, id: "", ParentId: personalDXCodeId, comment }
  const postTask = { action: TaskActions.Reply, id, ParentId: parentId, Comment: replyText };
  // console.log(' post Task ??????????????????')
  // console.dir(postTask)

  const result = await msalApi.post("/api/Patient/PostCommunicationsComment", postTask);
  return result.data;

  //todo REFACTOR 2 THIS
  // return msalApi
  //   .post('/Campaign/PostTaskComment', {
  //     commentId,
  //     id,
  //     commentText,
  //      action: TaskActions.Reply,
  //   })
  //   .then((response) => response.data)
}
export async function editCOMMsComment(data) {
  // console.log('API  editCOMMsComment ' , data)

  // console.dir(data)
  // console.log('_________end	')
  const parentId = data.ParentId;
  const id = data.Id;
  const editValue = data.editValue;
  const patientId = data.patientId;

  const postTask = { action: TaskActions.Edit, id, parentId, Comment: editValue };
  const result = await msalApi.post("/api/Patient/PostCommunicationsComment", postTask);
  return result.data;
}
export async function deleteCOMMsComment(data) {
  const parentId = data.ParentId;
  const id = data.Id;
  const patientId = data.patientId;
  const postTask = { action: TaskActions.Delete, id, parentId, PersonId: patientId };
  const result = await msalApi.post("/api/Patient/PostCommunicationsComment", postTask);
  return result.data;

  //todo REFACTOR
  //  return msalApi.delete('/Campaign/PostTaskComment', {
  //       params: {
  //       commentId: commentId,
  //           action: TaskActions.Delete,
  //       }
  //     })
  //     .then((response) => response.data)
}
// * MEASURES Comments

export async function postMeasuresComment(id: string, personalDXCodeId: number, comment: string) {
  //console.clear()()

  // console.log('				123  			*****   POSTing FROM API :::  postMeasuresComment')
  // console.log(' 										id: ', id)
  // console.log(' 										personalDXCodeId: ', personalDXCodeId)
  // console.log(' 										comment: ', comment)

  const postTask = { action: TaskActions.Add, id: "", ParentId: personalDXCodeId, comment };

  // console.log('postTask')
  // console.log(postTask)

  const result = await msalApi.post("/api/Patient/PostContractMeasuresComment", postTask);
  return result.data;

  //? REFACTOR 2 THIS
  //return msalApi.post('/Campaign/PostTaskComment', postTask).then((response) => {      response.data    })
}

export async function replyMeasuresComment(data) {
  //console.clear()()
  // console.log('🚀 ----------------------------------------------------------------------------------------------------🚀')
  // console.log('🚀 ~ file: discreteDataApi.ts ~ line : 243                     replyMeasuresComment data: ' + data)
  // console.log('🚀 ----------------------------------------------------------------------------------------------------🚀')
  //
  // console.log('22222')
  // console.dir(data)
  // console.log('22222')

  // console.log('--------------------------------  check DATA for patient BIND ')

  const parentId = data.parentId;
  const id = data.Id;
  const replyText = data.replyText;
  //const patientId = data.patientId

  //	const postTask = { action: TaskActions.Add, id: "", ParentId: personalDXCodeId, comment }
  const postTask = { action: TaskActions.Reply, id, parentId, Comment: replyText };

  // console.log(' 										POSTING     REPLY    MEASURES       ??????????????????')
  // console.dir(postTask)

  const result = await msalApi.post("/api/Patient/PostContractMeasuresComment", postTask);
  return result.data;

  //todo REFACTOR 2 THIS
  // return msalApi
  //   .post('/Campaign/PostTaskComment', {
  //     commentId,
  //     id,
  //     commentText,
  //      action: TaskActions.Reply,
  //   })
  //   .then((response) => response.data)
}
export async function editMeasuresComment(data) {
  // console.log('API  editANNONComment ' , data)

  // console.dir(data)
  // console.log('_________end	')
  // console.log('--------------------------------  check DATA for patient BIND ')

  const parentId = data.parentId;
  const id = data.Id;
  const editValue = data.editValue;
  const patientId = data.patientId;

  const postTask = { action: TaskActions.Edit, id, parentId, Comment: editValue };
  const result = await msalApi.post("/api/Patient/PostContractMeasuresComment", postTask);
  return result.data;
}
export async function deleteMeasuresComment(data) {
  // console.dir(data)
  // console.log('deleteMeasuresComment	')
  // console.log('--------------------------------  check DATA for patient BIND ')

  const parentId = data.parentId;
  const id = data.Id;
  const patientId = data.patientId;
  const postTask = { action: TaskActions.Delete, id, parentId, PersonId: patientId };
  const result = await msalApi.post("/api/Patient/PostContractMeasuresComment", postTask);
  return result.data;

  //todo REFACTOR
  //  return msalApi.delete('/Campaign/PostTaskComment', {
  //       params: {
  //       commentId: commentId,
  //           action: TaskActions.Delete,
  //       }
  //     })
  //     .then((response) => response.data)
}

// & ANNOTATION Comments
export async function postAnnotationComment(id: string, personalDXCodeId: number, comment: string) {
  //// //console.clear()()
  // console.log('				123  			*****   POSTing FROM API :::  postTaskComment')
  // console.log(' 										id: ', id)
  // console.log(' 										personalDXCodeId: ', personalDXCodeId)
  // console.log(' 										comment: ', comment)

  const postTask = { action: TaskActions.Add, id: "", ParentId: personalDXCodeId, comment };

  const result = await msalApi.post("/api/Patient/PostAnnotationComment", postTask);

  return result.data;

  //? REFACTOR 2 THIS
  //return msalApi.post('/Campaign/PostTaskComment', postTask).then((response) => {      response.data    })
}
export async function replyANNONComment(data) {
  // //console.clear()()
  // console.log('🚀 ----------------------------------------------------------------------------------------------------🚀')
  // console.log('🚀 ~ file: discreteDataApi.ts ~ line 147 ~ replyANNONComment ~ replyANNONComment  data: ' + data)
  // console.log('🚀 ----------------------------------------------------------------------------------------------------🚀')

  // console.log('22222')
  // console.dir(data)
  // console.log('22222')

  // console.log('--------------------------------  end ')

  const parentId = data.ParentId;
  const id = data.Id;
  const replyText = data.replyText;
  //const patientId = data.patientId

  //	const postTask = { action: TaskActions.Add, id: "", ParentId: personalDXCodeId, comment }
  const postTask = { action: TaskActions.Reply, id, parentId, Comment: replyText };

  // console.log(' post Task ??????????????????')
  // console.dir(postTask)

  const result = await msalApi.post("/api/Patient/PostAnnotationComment", postTask);
  return result.data;

  //todo REFACTOR 2 THIS
  // return msalApi
  //   .post('/Campaign/PostTaskComment', {
  //     commentId,
  //     id,
  //     commentText,
  //      action: TaskActions.Reply,
  //   })
  //   .then((response) => response.data)
}
export async function editANNONComment(data) {
  // console.log('API  editANNONComment ' , data)

  // console.dir(data)
  // console.log('_________end	')
  const parentId = data.ParentId;
  const id = data.Id;
  const editValue = data.editValue;
  const patientId = data.patientId;

  const postTask = { action: TaskActions.Edit, id, parentId, Comment: editValue };
  const result = await msalApi.post("/api/Patient/PostAnnotationComment", postTask);
  return result.data;
}
export async function deleteANNONComment(data) {
  const parentId = data.ParentId;
  const id = data.Id;
  const patientId = data.patientId;
  const postTask = { action: TaskActions.Delete, id, parentId, PersonId: patientId };
  const result = await msalApi.post("/api/Patient/PostAnnotationComment", postTask);
  return result.data;

  //todo REFACTOR
  //  return msalApi.delete('/Campaign/PostTaskComment', {
  //       params: {
  //       commentId: commentId,
  //           action: TaskActions.Delete,
  //       }
  //     })
  //     .then((response) => response.data)
}

export async function createNewTasks(data) {
  // console.clear()

  // console.log('DATA >>>>>>>>>')
  // console.log(data)
  // console.log(data.SelectedRecords)

  // PersonId: data.PersonId
  // console.log(data.patientId)

  const newTask = {
    Action: TaskActions.Add,
    subject: data.subject,
    body: data.body,
    date: data.date,
    Recipients: data.recipients,
    RecipientsCC: data.recipientsCC,
    IncludeContext: data.includeContext,
    AllowDelegation: data.allowDelegation,
    Required: data.required,
    Priority: data.priority,

    PersonId: data.patientId,
    SelectedRecords: data.SelectedRecords,
    TaskTypeD: data.taskTypes,

    // TaskType: {},
    // Attachments: [],
    // Context: "",
    // CategoryId: "",
    // CCRecipients: [],
    // IsTask: false,
    // PatientOutreach: false,
  };

  // console.log(' 			newTask')
  // console.log( newTask)

  const result = await msalApi.post("/api/Campaign/CreateNewTasks", newTask);
  return result.data;

  //todo REFACTOR 2 THIS
  // return msalApi
  //   .post('/Campaign/PostTaskComment', {
  //     commentId,
  //     id,
  //     commentText,
  //      action: TaskActions.Reply,
  //   })
  //   .then((response) => response.data)
}
export async function reAssignTasks(data) {
  // // console.log(' 					reAssignTasks : prepping API call >>> to ')

  // // console.log('DATA')
  // // // console.dir(data)

  const body = data.body;
  const recipient = data.recipients[0];
  // // console.log(' rec ', recipient)

  // //todo check THIS
  const selectedRecordIds = data.selectedPatients;
  // // console.log('     REPLY > POST TASK = recordIds     selectedRecordIds  selectedPatients  ', selectedRecordIds)

  const delegatePatientsWorkRequest = {
    action: TaskActions.ReAssign,
    recipient,
    Message: body,
    SourceId: 99,
    ContainerId: data.ContainerId,
    RecordIds: selectedRecordIds,
  };

  //const postTask = {action: TaskActions.Reply,Comment: replyText,commentId,id,PersonId: patientId}

  // // // console.log('POST TASK obj >>     ADDED     PERSON ID : ' + patientId)
  // // console.log('     				POST 			********			> POST delegatePatientsWorkRequest = ', delegatePatientsWorkRequest)

  const result = await msalApi.post("/api/Campaign/DelegateWork", delegatePatientsWorkRequest);
  return result.data;

  //todo REFACTOR 2 THIS
  // return msalApi
  //   .post('/Campaign/PostTaskComment', {
  //     commentId,
  //     id,
  //     commentText,
  //      action: TaskActions.Reply,
  //   })
  //   .then((response) => response.data)
}

export function getPatientAllergies(patientId: number) {
  // console.log('			discreteDATA  API >  getPatientAllergies')
  return msalApi.get(`/api/Patient/GetPatientAllergies?personId=${patientId}`).then((result) => result.data);
}

export function getPatientCommunications(patientId: number) {
  // console.log('GET PATIENT  COMMUNICATIONS')

  return msalApi.get(`/api/Patient/GetPatientCommunications?personId=${patientId}`).then((result) => result.data);
}

export function getPatientMedications(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientMedications?personId=${patientId}`).then((result) => result.data);
}
export function getPatientMeasures(patientId: number) {
  // console.log('			discreteDataAPI > getPatientMeasures')
  return msalApi.get(`/api/Patient/GetPatientContractMeasures?personId=${patientId}`).then((result) => result.data);
}
// *NEW  getGetContractMeasureComments
export function getContractMeasureComments(id: number) {
  // console.log('		                 NEW     0918          	discreteDataAPI > getContractMeasureComments')
  return msalApi.get(`/api/Patient/GetContractMeasureComments?id=${id}`).then((result) => result.data);
}

export function getPatientLabs(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientLabs?personId=${patientId}`).then((result) => result.data);
}

export function getPatientVitals(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientVitals?personId=${patientId}`).then((result) => result.data);
}
export function getPatientVitalsData(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientVitalsData?personId=${patientId}`).then((result) => result.data);
}


export function getPatientImmunizations(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientImmunizations?personId=${patientId}`).then((result) => result.data);
}

export function getInPatientVisits(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientInPatientVisits?personId=${patientId}`).then((result) => result.data);
}
// // Documents
export function getPatientDocuments(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientDocuments?personId=${patientId}`).then((result) => result.data);
}
export function getPatientEncounters(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientEncounters?personId=${patientId}`).then((result) => result.data);
}

export function getPatientAllScriptDocuments(patientId: number, id: string) {
  return msalApi.get(`/api/Patient/GetAllScriptsDocument?personId=${patientId}&id=${id}`).then((result) => result.data);
}

export function getPatientProcedures(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientProcedures?personId=${patientId}`).then((result) => result.data);
}

export function getPatientReminders(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientReminders?personId=${patientId}`).then((result) => result.data);
}

// & getPatientTasks
export function getPatientTasks(patientId: number) {
  // console.log(' getPatientTasks')
  return msalApi.get(`/api/Campaign/GetMyWorkDetails?personId=${patientId}`).then((result) => result.data);
}

// * getPatientAssmts

export function checkPrePatientAssmt(patientId: number) {
  return msalApi.get(`/api/Patient/PreAssessment?personId=${patientId}`).then((result) => result.data);
}


export function getPatientAssmts(patientId: number) {
  return msalApi.get(`/api/Patient/GetPatientAssessments?personId=${patientId}`).then((result) => result.data);
}
export function getPatientAssmtList(patientId: number) {
  // return msalApi.get(`/api/Patient/GetPatientAssessmentList?personId=${patientId}`).then((result) => result.data)
  return msalApi.get(`/api/Patient/GetPatientAssessmentList?personId=${patientId}`).then((result) => result.data);
}
export function commitNewAssmt(patientId: number, assessmentId: number, statusCode?: number) {
  // console.log('  toDO  BUILD overload    API > commitNewAssmt         >>>>>>>>')
  return msalApi.post(`/api/Patient/PostAssessmentStatusChange?personId=${patientId}&assessmentId=${assessmentId}&statusCode=${statusCode}`).then((result) => result.data);
}
// // TO DELTE ???
// export function putTaskStatus(patientId: number) {
// 	return msalApi.get(`/Campaign/PutTaskStatus?personId=${patientId}`).then((result) => result.data)
// }

export function downloadLabReport(patientName, documentId = 0, personId = 41686) {
  msalApi({
    url: `/api/PatientDiscreteData/GetAllScriptsDocument?personId=${personId}&documentId=${documentId}`,
    method: "GET",
    responseType: "blob", // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${patientName}-${todaysDateFormatted()}.pdf`);
    document.body.appendChild(link);
    link.click();
  });
}

// export async function postDXAssessmentDetail(data){
// 	const postTask = {
// 		PersonalDXCodeId,
// 		AssessmentId,
// 		Interview,
// 		Exam,
// 		Assessment,
// 		Decide,
// 	 }

// 	const result = await msalApi.post('/api/Patient/PostAnnotationComment', postTask)

// 	return result.data
// }
